import { useEffect } from 'react';

/**
 * Change status bar color on IOS when modal is shown.
 * 
 * @param showModal 
 */
const useStatusBarEffect = (showModal: boolean) => {
  useEffect(() => {
    // Only available on mobile, via the Cordova statusbar plugin
    if (!window.StatusBar || !window.cordova) {
      return;
    }

    // Only change status bar color on IOS
    if (window.cordova.platformId !== 'ios') {
      return;
    }

    if (showModal) {
      window.StatusBar.styleLightContent();
    } else {
      window.StatusBar.styleDefault();
    }
  }, [showModal]);
};

export default useStatusBarEffect;